import React from 'react';
import { PageTitle, ContactContainer, Form, Input, Seo } from '../components/ui';
import lang from '../assets/lang';

export const JoinUs = () => {
	const getForm = () => {
		return lang.joinUsForm.map(el =>
			<Input key={el.placeholder} type={el.type} name={el.name} placeholder={el.placeholder}
			       options={el.options} />
		);
	};

	return (
		<div>
			<Seo
				pageTitle={lang.joinUsSeo.pageTitle}
				metaDescription={lang.joinUsSeo.metaDescription}
				metaKeywords={lang.joinUsSeo.metaKeywords}
			/>
			<PageTitle
				title={lang.joinUsTitle}
				text={lang.joinUsText}
			/>

			<ContactContainer>
				<Form
					action="https://formspree.io/info@swazerlab.com"
					submitText={lang.textFormSubmitText}
				>
					{getForm()}
				</Form>
			</ContactContainer>
		</div>

	);
};



// WEBPACK FOOTER //
// ./src/pages/JoinUs.js